import React from "react"
import { CalendarDays, Clock } from "lucide-react"
import { Badge } from "../../../ui/badge"
import { Card, CardContent, CardHeader } from "../../../ui/card"

const getBadgeColor = type => {
  switch (type) {
    case "New":
      return "bg-oye-soft-green text-green-800 hover:bg-oye-soft-green"
    case "Improved":
      return "bg-oye-soft-peach text-amber-800 hover:bg-oye-soft-peach"
    case "Fixed":
      return "bg-oye-soft-yellow text-amber-800 hover:bg-oye-soft-yellow"
    case "Announcement":
      return "bg-oye-light-purple text-purple-800 hover:bg-oye-light-purple"
    default:
      return ""
  }
}

const updates = [
  {
    id: 1,
    date: "May 5, 2025",
    title: "Mobile App Launch",
    description:
      "We're excited to announce the launch of our mobile app, now available for iOS and Android. Download it today for a seamless on-the-go experience.",
    type: "New",
    time: "10:30 AM"
  },
  {
    id: 2,
    date: "May 3, 2025",
    title: "Enhanced Creator Dashboard",
    description:
      "We've completely redesigned the creator analytics dashboard with more detailed performance metrics and improved visualization tools.",
    type: "Improved",
    time: "2:15 PM"
  },
  {
    id: 3,
    date: "April 28, 2025",
    title: "Payment Processing Bug Fix",
    description:
      "We've resolved an issue that was causing delays in payment processing for some creators. All payments should now process within 24 hours.",
    type: "Fixed",
    time: "11:00 AM"
  },
  {
    id: 4,
    date: "April 24, 2025",
    title: "Community Guidelines Update",
    description:
      "We've updated our community guidelines to provide clearer guidance on acceptable content. Please review these changes to ensure your content complies.",
    type: "Announcement",
    time: "9:45 AM"
  },
  {
    id: 5,
    date: "April 20, 2025",
    title: "Content Scheduling Feature",
    description:
      "Now you can schedule your content to be published at a later time. This feature is available for all creator accounts.",
    type: "New",
    time: "3:30 PM"
  },
  {
    id: 6,
    date: "April 15, 2025",
    title: "Search Algorithm Improvements",
    description:
      "We've optimized our search algorithm to help users find relevant content more easily, and to help creators get discovered by the right audience.",
    type: "Improved",
    time: "1:00 PM"
  }
]

const UpdatesList = ({ activeFilter }) => {
  const filteredUpdates =
    activeFilter === "All"
      ? updates
      : updates.filter(update => update.type === activeFilter)

  return (
    <div className="space-y-8">
      {filteredUpdates.map(update => (
        <Card
          key={update.id}
          className="overflow-hidden transition-all duration-300 hover:transform hover:scale-[1.01] relative"
          style={{
            boxShadow: "0 10px 30px -15px rgba(82, 56, 128, 0.15)",
            borderRadius: "12px"
          }}
        >
          <div className="absolute w-[180px] h-[180px] rounded-full bg-oye-light-purple/10 blur-3xl -right-20 -top-20 z-0"></div>
          <CardHeader className="bg-gray-50/80 pb-2 relative z-10">
            <div className="flex justify-between items-start">
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <CalendarDays className="h-4 w-4" />
                <span>{update.date}</span>
                {update.time && (
                  <>
                    <span>•</span>
                    <Clock className="h-4 w-4" />
                    <span>{update.time}</span>
                  </>
                )}
              </div>
              <Badge className={`${getBadgeColor(update.type)} border-none`}>
                {update.type}
              </Badge>
            </div>
          </CardHeader>
          <CardContent className="pt-4 relative z-10">
            <h3 className="text-xl font-semibold mb-2">{update.title}</h3>
            <p className="text-gray-600">{update.description}</p>
          </CardContent>
        </Card>
      ))}

      {filteredUpdates.length === 0 && (
        <div className="text-center py-10">
          <p className="text-gray-500">No updates found for this category.</p>
        </div>
      )}
    </div>
  )
}

export default UpdatesList;
